// extracted by mini-css-extract-plugin
export default {"wrapper":"js-z","response":"ks-z","error":"ls-z","disabled":"ms-z","buttons":"ns-z","feedbackQuestionSection":"os-z","yesNoWrapper":"ps-z"};